<div class="legal-document-page">
  <app-header
    [title]="'Protection des mineurs'"
    [showBackButton]="true"
    [showMenu]="false"
    [usePageBackground]="true"
  ></app-header>

  <div class="page-content">
    <article class="legal-card">
      <h2>Protection des mineurs</h2>

      <p>
        Saloons est une application sociale destinée uniquement aux utilisateurs majeurs.
        L’utilisation de l’application par des mineurs est interdite.
      </p>

      <p>
        Nous appliquons une politique de tolérance zéro concernant toute forme d’exploitation,
        d’abus sexuel, de sollicitation, de mise en danger ou de comportement inapproprié impliquant
        des mineurs.
      </p>

      <p>Les comportements suivants sont strictement interdits sur Saloons :</p>

      <ul>
        <li>
          tout contenu représentant, sollicitant, partageant ou faisant la promotion d’abus sexuels
          sur mineurs ;
        </li>
        <li>toute tentative de contact inapproprié avec une personne mineure ;</li>
        <li>
          tout comportement de manipulation, de grooming, de sollicitation sexuelle ou
          d’exploitation ;
        </li>
        <li>tout contenu ou comportement visant à mettre un mineur en danger ;</li>
        <li>toute utilisation de l’application par une personne mineure.</li>
      </ul>

      <p>
        Les utilisateurs peuvent signaler un contenu, un profil ou un comportement suspect
        directement depuis l’application lorsque la fonctionnalité est disponible, ou en nous
        contactant à l’adresse suivante :
      </p>

      <p class="legal-contact">
        <a href="mailto:support@saloons.fr">support&#64;saloons.fr</a>
      </p>

      <p>
        Tout compte impliqué dans un comportement contraire à ces règles peut être suspendu ou
        supprimé immédiatement. Lorsque cela est nécessaire, nous pouvons transmettre les
        informations pertinentes aux autorités compétentes.
      </p>

      <p>
        Les signalements liés à la protection des mineurs sont traités en priorité afin de maintenir
        un environnement sûr pour les utilisateurs.
      </p>

      <p>Contact dédié à la protection des mineurs :</p>

      <p class="legal-contact">
        <a href="mailto:support@saloons.fr">support&#64;saloons.fr</a>
      </p>
    </article>
  </div>
</div>
